import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { LinkGenerator } from "@lululemon/ui-library";
import { createEncodedKey } from "@lululemon/ecom-common/src/util/helpers";

import styles from "./agreements.module.scss";

const Agreements = ({ agreements = "" }) => {
  // NOTE: This pattern matching fails if href attributes use single quotes
  const ANCHOR_TAG_PATTERN = /(<a href="[^"]+[^>]*">[^<]+<\/a>)/g;
  const ANCHOR_TAG_GROUPS_PATTERN = /<a href="([^"]+)">([^<]+)<\/a>/;

  const splitAgreements = agreements.split(ANCHOR_TAG_PATTERN);

  return (
    <p className={classNames("lll-text-body-3", styles.footerText)}>
      {splitAgreements.map((agreementSubstring) => {
        if (!agreementSubstring.match(ANCHOR_TAG_PATTERN)) {
          return (
            <span key={createEncodedKey(agreementSubstring)}>
              {agreementSubstring}
            </span>
          );
        }

        const anchorInfo = agreementSubstring.split(ANCHOR_TAG_GROUPS_PATTERN);
        /* eslint-disable no-unused-vars */
        const [_, anchorLink, anchorLabel] = anchorInfo;

        return (
          <LinkGenerator
            key={createEncodedKey(agreementSubstring)}
            target="_blank"
            rel="noopener noreferrer"
            className={classNames("lll-link-primary", styles.link)}
            href={anchorLink}
          >
            {anchorLabel}
          </LinkGenerator>
        );
      })}
    </p>
  );
};

Agreements.propTypes = {
  agreements: PropTypes.string.isRequired,
};

export default Agreements;
